import { EContainerTypes } from '../types';

export enum ELabelActionsType {
  StepYes = 'stepYes',
  StepNo = 'stepNo',
}

export type TLabelActions = Partial<Record<ELabelActionsType, EContainerTypes>>;

export const useGetLabelActions = (currContainerName: EContainerTypes): TLabelActions => {
  const stepNo = EContainerTypes.FormFailed;

  switch (currContainerName) {
    case EContainerTypes.AddLabelWithoutProfiling:
      return { stepYes: EContainerTypes.LabelAdded, stepNo };
    case EContainerTypes.IsMorgageQuestion:
      return { stepYes: EContainerTypes.OwnerCitizenshipQuestion, stepNo: EContainerTypes.EncumbranceWillBeRemoved };
    case EContainerTypes.EncumbranceWillBeRemoved:
      return { stepYes: EContainerTypes.OwnerCitizenshipQuestion, stepNo };
    case EContainerTypes.OwnerCitizenshipQuestion:
      return { stepYes: EContainerTypes.MaternityCapitalQuestion, stepNo };
    case EContainerTypes.MaternityCapitalQuestion:
      return { stepYes: EContainerTypes.LabelAdded, stepNo };

    // Последние два экрана зацикливаются друг на друга
    case EContainerTypes.LabelAdded:
      return { stepYes: EContainerTypes.LabelRemoved, stepNo };
    case EContainerTypes.LabelRemoved:
      return { stepYes: EContainerTypes.LabelAdded, stepNo };

    /* istanbul ignore next - только для дева */
    default:
      return {};
  }
};
